import { css } from '@emotion/core';
import { textStyle, Heading, minimumWidth, styled } from '@feast-it/ui/light';

export const Container = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacing[4]};
    padding: 0 ${theme.spacing[4]};
    text-align: center;

    ${minimumWidth(theme.breakpoints.small)} {
      padding: 0 ${theme.spacing[6]};
    }

    ${minimumWidth(theme.breakpoints.small)} {
      padding: 0 ${theme.spacing[8]};
    }
  `
);

export const SuppliersTitle = styled(Heading)(
  ({ theme }) => css`
    ${textStyle(theme, 'headingMobileExtraLarge')};

    ${minimumWidth(theme.breakpoints.medium)} {
      ${textStyle(theme, 'headingExtraLarge')};
    }
  `
);

export const EnquireLink = styled.a(
  ({ theme, isDark }) => css`
    color: ${isDark ? theme.colors.paleYellow : theme.colors.mediumBlue};
    text-decoration: none;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  `
);
